import { Button, Flex } from "antd";
import { styled } from "styled-components";

export const LandingContainer = styled.div`
    width: 100%;
    height: 100%;
    color: white;
    background-color: #121212;
`;

export const Welcome = styled.div`
    position: relative;
    height: 100%;
`;

export const ImageContainer = styled.div`
    position: absolute;
    inset: 0;
`;

export const WelcomeContent = styled(Flex)`
    position: relative;
    height: 100%;
    text-align: justify;
    padding: 20px;
    padding-inline: 50px;
    backdrop-filter: blur(2px);
`;

export const WelcomeTitle = styled.span`
    font-family: Suburban;
    font-size: 5rem;
    letter-spacing: -1px;
    line-height: 1.25;
    margin-bottom: 20ox;
    max-width: 50%;
    text-align: left;

    @media (max-width: 820px) {
        font-size: clamp(1.75rem, 1.5764rem + 2.7778vw, 3rem);
        max-width: 90%;
    }
`;

export const WelcomeDescription = styled.span`
    font-family: Roboto-Thin;
    line-height: 1.5;
    font-size: 1rem;
    margin-bottom: 20px;
    max-width: 50%;
    -webkit-user-select: none;
    text-align: left;

    @media (max-width: 820px) {
        font-size: clamp(0.7rem, 0.6583rem + 0.6667vw, 1rem);
        max-width: 90%;
    }
`;

export const CTA = styled(Button)`
    font-size: 0.8rem;
    border-radius: 5px;
    background-color: #0d9ce8;
    border: none;
    height: 40px;
    padding: 5px 20px;
    white-space: nowrap;
    cursor: pointer;
    font-family: Roboto-Thin;
`;

export const SectionTitle = styled.span`
    font-size: 3rem;
    text-align: center;
    margin-bottom: 50px;
    margin-top: 20px;
    font-family: Suburban;
`;

export const PickContainer = styled.div`
    background-color: #2d2d2d;
    border-radius: 10px;
    cursor: pointer;
    overflow: hidden;
    height: auto;
    width: 335px;

    @media (max-width: 450px) {
        width: 100%;
    }
`;

export const PickImageContainer = styled.div`
    position: relative;
    height: 200px;
    
    @media (max-width: 450px) {
        height: auto;
    }

`;

export const FooterContainer = styled.div`
    max-width: 80%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;

    @media (max-width: 750px) {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
    }
   
    @media (max-width: 500px) {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
    }
`;